// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Corp__Wrapper_dBxA7","Inner":"Corp__Inner_2JCTZ grid","Header":"Corp__Header_2avPe","Title":"Corp__Title_cwIYF","Description":"Corp__Description_1ZCMC"};